// extracted by mini-css-extract-plugin
module.exports = {"title":"title___1KX2j","CustomerPickupScreenSettings":"CustomerPickupScreenSettings___1RR7a"};